// modules/website/components/GalleryComponent.tsx

import React, { useState } from 'react';
import { GalleryData } from '@/types';
import { X } from 'lucide-react';

interface Props {
  data: GalleryData;
  settings: any;
}

export const GalleryComponent: React.FC<Props> = ({ data, settings }) => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  return (
    <div 
      className="py-20 px-6"
      style={{
        backgroundColor: settings.backgroundColor || '#ffffff',
      }}
    >
      <div className="max-w-7xl mx-auto">
        {data.title && (
          <h2 className="text-4xl font-bold text-center mb-12">
            {data.title}
          </h2>
        )}
        
        <div className={`grid gap-${data.gap || 4} ${
          data.columns === 2 ? 'grid-cols-1 md:grid-cols-2' :
          data.columns === 3 ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' :
          'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
        }`}>
          {data.images.map((image, index) => (
            <div 
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all"
              onClick={() => setSelectedImage(index)}
            >
              <img 
                src={image.src || '/placeholder-image.jpg'} 
                alt={image.alt}
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              {image.caption && (
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-4 transform translate-y-full group-hover:translate-y-0 transition-transform">
                  <p className="text-sm">{image.caption}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-4 right-4 text-white hover:text-gray-300"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <img 
            src={data.images[selectedImage].src} 
            alt={data.images[selectedImage].alt}
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </div>
  );
};
